import $ from "jquery";
import { application } from "../application/application";
import { courseBasicInfo } from "./courseBasicInfo";
import { dataaccess } from "../dataaccess/dataContext";
import { ethosBank } from "./ethosBank";
import { forms } from "../framework/forms";
import { services } from "../services/notificationService";

let studentCurrentPage = 1;
let facultyCurrentPage = 1;
let studentHasNextPage = "False";
let facultyHasNextPage = "False";
let params;
let processingData = 0;

function init() {
    processingData = 0;

    $(document).on("click", ".Student-Next", function () {
        if (processingData !== 0) {
            return;
        }
        $(this).prop("disabled", true);
        processingDataOn();
        studentCurrentPage++;
        populateStudentSearchTable();
        processingDataOff();
        $(this).prop("disabled", false);
    });
    $(document).on("click", ".Student-Previous", function () {
        if (updateStudentResultsView()) return;
        if (processingData !== 0) {
            return;
        }
        $(this).prop("disabled", true);
        processingDataOn();
       studentCurrentPage--;
        populateStudentSearchTable();
        processingDataOff();
        $(this).prop("disabled", false);
    });
    $(document).on("click", ".Faculty-Next", function () {
        if (processingData !== 0) {
            return;
        }
        $(this).prop("disabled", true);
        processingDataOn();
      facultyCurrentPage++;
        populateFacultySearchTable();
        processingDataOff();
        $(this).prop("disabled", false);
    });
    $(document).on("click", ".Faculty-Previous", function () {
        if (updateFacultyResultsView()) return;
        if (processingData !== 0) {
            return;
        }
        processingDataOn();
        $(this).prop("disabled", true);
     facultyCurrentPage--;
        populateFacultySearchTable();
        processingDataOff();
        $(this).prop("disabled", false);
   });
    $(document).on("click", ".add-Student", function () {
        if (processingData !== 0) {
            return;
        }
        processingDataOn();
        $(this).prop("disabled", true);
        $(this).text("");
        $(this).addClass("btn-loading");
        const row = $(this).closest("tr");
        const id = row.attr("data-personId");
        dataaccess
            .post({ url: "/Course/AddStudent/" + id + "/" + $("#courseId").val() + "/Student" })
            .done(function () {
                populateStudentTable();
                populateStudentSearchTable();
                processingDataOff();
            });
    });
    $(document).on("click", ".add-Faculty", function () {
        if (processingData !== 0) {
            return;
        }
        processingDataOn();
        $(this).prop("disabled", true);
        $(this).text("");
        $(this).addClass("btn-loading");
        const row = $(this).closest("tr");
        const id = row.attr("data-personId");
        dataaccess
            .post({ url: "/Course/AddStudent/" + id + "/" + $("#courseId").val() + "/Faculty" })
            .done(function () {
                populateFacultyTable();
                populateFacultySearchTable();
                processingDataOff();
            });
    });
    $(document).on("dblclick", "#studentTable tbody tr", function () {
        forms.showSpinner();
        const id = $(this).attr("data-personId");
        window.location.href = application.baseUrl + "/person/index/" + id;
    });
    $(document).on("dblclick", "#facultyTable tbody tr", function () {
        forms.showSpinner();
        const id = $(this).attr("data-personId");
        window.location.href = application.baseUrl + "/person/index/" + id;
    });
    $(document).on("change", "#selectAllStudentsToggle", selectAllStudentsToggle);
    $(document).on("change", "#selectAllFacultyToggle", selectAllFacultyToggle);
    $(document).on("click", "#Student-SearchBtn", "SearchClicked", populateStudentSearchTable);
    $(document).on("click", "#Faculty-SearchBtn", "FacultyClicked", populateFacultySearchTable);
    $(document).on("click", "#addStudentButton", populateStudentSearchTable);
    $(document).on("click", "#addFacultyButton", populateFacultySearchTable);
    $(document).on("click", "#exportStudentsBtn", exportStudentRosterToExcel);
    $(document).on("click", "#exportFacultyBtn", exportFacultyRosterToExcel);
    $(document).on("click", "#facultyStudentEvaluationBtn", facultyStudentEvaluationPage);
    $(document).on("submit", "#add-to-roster-form", function (e) {
        e.preventDefault();
    });
    $(document).on("change", ".radio-participant-type", function () {
        const radios = $(this)
            .closest("tr")
            .find(".radio-participant-type:radio:checked");
        const id = $(this)
            .closest("tr")
            .attr("data-personId");
        const participantTypes = $.map(radios, function (elm) {
            return $(elm).val();
        });
        dataaccess
            .put({
                url:
                    "/Course/ChangeParticipantTypes/" +
                    id +
                    "/" +
                    $("#courseId").val() +
                    "/" +
                    JSON.stringify(participantTypes)
            })
            .done(function () {
                populateStudentTable();
            });
    });

    $(document).on("change", ".js-radio-tablename-type", function () {
        const isStudentTable = $(this).closest("table").is("#studentTable");
        const isFacultyTable = $(this).closest("table").is("#facultyTable");
        forms.showSpinner("Saving...", false);
        const tableName = $(this)
            .closest("tr")
            .find(".js-radio-tablename-type:radio:checked").val();
        const personId = $(this)
            .closest("tr")
            .attr("data-personId");

        if (isStudentTable) {
            $("#studentTableName").html(tableName);
        } else if (isFacultyTable) {
            $("#facultyTableName").html(tableName);
        }

        dataaccess
            .put({
                url:
                    "/Course/ChangeTableName/" +
                    personId +
                    "/" +
                    $("#courseId").val() +
                    "/" +
                    tableName
            })
            .done(function () {
                if (isStudentTable) {
                    populateStudentTable();
                } else if (isFacultyTable) {
                    populateFacultyTable();
                }
            }).always(function () {
                forms.hideSpinner();
            });
    });

    $(document).on("click", ".js-role-save", function () {
        const checkboxes = $(this)
            .closest("tr")
            .find(".js-chk-role:checkbox:checked");
        const id = $(this)
            .closest("tr")
            .attr("data-personId");
        const rolesToSave = $.map(checkboxes, function (elm) {
            return $(elm).val();
        });
        const roleNames = $.map(checkboxes, function (elm) {
            return $(elm).attr("rtaName");
        });
        let candidateCount = 0;
        for (let intx = 0; intx < roleNames.length; intx++) {
            if (roleNames[intx].indexOf("Candidate") !== -1) {
                candidateCount++;
            }
        }
        if (candidateCount > 1) {
            alert("You can only add 1 candidate as a role");
        } else {
            dataaccess
                .put({
                    url:
                        "/Course/ChangeRoles/" +
                        id +
                        "/" +
                        $("#courseId").val() +
                        "/" +
                        JSON.stringify(rolesToSave)
                })
                .done(function () {
                    populateFacultyTable();
                });
        }
    });
    $(document).on("click", ".js-teaching-assignment-save", function () {
        const checkboxes = $(this)
            .closest("tr")
            .find(".js-chk-teaching-assignment:checkbox:checked");
        const id = $(this)
            .closest("tr")
            .attr("data-personId");
        const teachingAssignmentsToSave = $.map(checkboxes, function (elm) {
            return $(elm).val();
        });
        dataaccess
            .put({
                url:
                    "/Course/ChangeTeachingAssignments/" +
                    id +
                    "/" +
                    $("#courseId").val() +
                    "/" +
                    JSON.stringify(teachingAssignmentsToSave)
            })
            .done(function () {
                populateFacultyTable();
            });
    });

    $(document).on("click", "#emailStudents, #emailFaculty", function () {
        let checkboxes;
        if ($(this)[0].id === "emailStudents") {
            checkboxes = $(this)
                .closest("table")
                .find(".js-chk-student-row:checkbox:checked");
        } else if ($(this)[0].id === "emailFaculty") {
            checkboxes = $(this)
                .closest("table")
                .find(".chk-faculty-row:checkbox:checked");
        }
        const emailAddresses = $.map(checkboxes, function (elm) {
            return $(elm).data("email");
        }).join(";");
        if (emailAddresses !== "") {
            window.location.href = "mailto:?bcc=" + emailAddresses;
        }
    });

    $(document).on("click", "#SendDisclosureEmail", function () {
        forms.showSpinner("Sending email...", false);
        const currentPersonId = $("input[name='CurrentPersonId']").val();

        const checkboxes = $(this)
            .closest("table")
            .find(".chk-faculty-row:checkbox:checked");

        const personCourseIds = $.map(checkboxes, function (elm) {
            return $(elm).data("personcourseid");
        });

        const params = {
            "data": {
                "CurrentPersonId": currentPersonId,
                "PersonCourseIds": personCourseIds
            },
            "url": "/CourseRoster/SendDisclosureReminder"
        };

        dataaccess
            .post(params)
            .done(function () {
                services.notificationService.success("Email has been sent.");
            })
            .fail(function (xhr, status, error) {
                try {
                    const json = $.parseJSON(xhr.responseText);
                    $.each(json, function (index, row) {
                        services.notificationService.error(row.description, 0);
                    });
                } catch (ex) {
                    // Displays default notificationService error.
                }
            })
            .always(function () {
                forms.hideSpinner();
                $("#facultyTable").find(".dropdown-toggle").trigger("click");
            });
    });

    $(document).on("click", "#SendCourseEnrollmentEmail", function () {
        $("#studentTable .dropdown-toggle").dropdown("toggle");

        const checkboxes = $(this)
            .closest("table")
            .find(".js-chk-student-row:checkbox:checked");

        if (checkboxes.length === 0) return;

        const arr = [];

        checkboxes.each(function () {
            arr.push($(this).val());
        });

        const courseId = $("#courseId").val();
        const json = { aptifyIds: arr };
        const queryString = $.param(json, true);

        params = {
            url: `/EthosBank/Course/${courseId}/Email?${queryString}`,
            successMsg: "Successfully sent emails."
        };

        dataaccess.post(params);
    });

    $(document).on("click", ".js-emailStudentEvalReminder", function () {
        const currentPersonId = $(this).attr("data-currentPersonId");
        const personCourseId = $(this).attr("data-personCourseId");
        forms.showSpinner("Sending email...", false);

        params = {
            "data": {
                "CurrentPersonId": currentPersonId,
                "PersonCourseId": personCourseId
            },
            url: "/CourseRoster/SendCourseEvaluationReminder",
            successMsg: "Successfully sent email."
        };
        dataaccess.post(params)
            .done(function () {
                forms.hideSpinner();
            });
    });

    $(document).on("click", ".js-emailFacilitatorPreEvalReminder", function () {
        const currentPersonId = $(this).attr("data-currentPersonId");
        const personCourseId = $(this).attr("data-personCourseId");
        forms.showSpinner("Sending email...", false);

        params = {
            "data": {
                "CurrentPersonId": currentPersonId,
                "PersonCourseId": personCourseId
            },
            url: "/CourseRoster/SendCourseFacPreEvaluationReminder",
            successMsg: "Successfully sent email."
        };
        dataaccess.post(params)
            .done(function () {
                forms.hideSpinner();
            });
    });
    $(document).on("click", ".js-emailFacilitatorPostEvalReminder", function () {
        const currentPersonId = $(this).attr("data-currentPersonId");
        const personCourseId = $(this).attr("data-personCourseId");
        forms.showSpinner("Sending email...", false);

        params = {
            "data": {
                "CurrentPersonId": currentPersonId,
                "PersonCourseId": personCourseId
            },
            url: "/CourseRoster/SendCourseFacPostEvaluationReminder",
            successMsg: "Successfully sent email."
        };
        dataaccess.post(params)
            .done(function () {
                forms.hideSpinner();
            });
    });

    $(document).on("click", ".js-regenStudentEval", function () {
        const currentPersonId = $(this).attr("data-currentPersonId");
        const personCourseId = $(this).attr("data-personCourseId");
        forms.showSpinner("Generating Eval...", false);
        $(this).find('i').toggleClass('fa-times-circle fa-envelope');
        $(this).toggleClass('js-regenStudentEval js-emailStudentEvalReminder');
        
        params = {
            "data": {
                "CurrentPersonId": currentPersonId,
                "PersonCourseId": personCourseId
            },
            url: "/CourseRoster/RegenerateStudentEval",
            successMsg: "Successfully sent email."
        };
        dataaccess.post(params)
            .done(function () {
                forms.hideSpinner();
            });
    });

    $(document).on("click", "#removeStudents", function () {
        const checkboxes = $("#studentTable").find(".js-chk-student-row:checkbox:checked");
        const peopleToRemove = $.map(checkboxes, function (elm) {
            return $(elm).val();
        });

        $.each(peopleToRemove, function (index, value) {
            const isMAtlsChecked = $(`#${value}`).prop("checked");
            if (isMAtlsChecked) {
                $("#RemoveStudentsAlert").modal("show");
                return false;
            }

            const isLastItem = index === peopleToRemove.length - 1;
            if (isLastItem) {
                $("#ConfirmRemoveRoster").modal("show");
            }
        });
    });

    $(document).on("click", "#ConfirmRemoveStudents", function () {
        const checkboxes = $("#studentTable").find(".js-chk-student-row:checkbox:checked");
        const peopleToRemove = $.map(checkboxes, function (elm) {
            return $(elm).val();
        });
        dataaccess
            .post({
                url:
                    "/Course/RemovePersonsFromPersonCourses/" +
                    $("#courseId").val() +
                    "/" +
                    JSON.stringify(peopleToRemove)
            })
            .done(function () {
                populateStudentTable();
            });
    });

    $(document).on("click", "#ConfirmTransferButton", function () {
        const $transferBtn = $(this);
        const fromCourseId = $("#courseId").val();
        const toCourseId = $("#TransferToCourseId").val();
        const checkboxes = $("#studentTable").find(".js-chk-student-row:checkbox:checked");
        const personIds = $.map(checkboxes, function (elm) {
            return $(elm).val();
        });
        $transferBtn.prop("disabled", true);
        forms.showSpinner();
        dataaccess
            .post({
                url:
                    "/Course/Transfer/" +
                    fromCourseId +
                    "/" +
                    toCourseId +
                    "/" +
                    JSON.stringify(personIds)
            })
            .done(function (result) {
                $transferBtn.siblings(".text-danger").html("");

                if (result.validationResults !== undefined && result.validationResults.length > 0) {
                    let html = "<ul class='list-unstyled'>";

                    $.each(result.validationResults, function (i, val) {
                        html += `<li>${val.description}</li>`;
                    });

                    html += "</ul>";

                    $transferBtn.siblings(".text-danger").html(html);
                    $transferBtn.prop("disabled", false);
                } else {
                    location.reload();
                }
            })
            .fail(function () {
                $transferBtn.prop("disabled", false);
            });
    });

    $(document).on("click", "#CancelTransferButton", function () {
        $("#ConfirmTransferModal")
            .find(".text-danger")
            .html("");
        $("#ConfirmTransferModal").modal("hide");
    });

    $(document).on("click", "#removeFaculty", function () {
        const checkboxes = $(this)
            .closest("table")
            .find(".chk-faculty-row:checkbox:checked");
        const peopleToRemove = $.map(checkboxes, function (elm) {
            return $(elm).val();
        });
        dataaccess
            .post({
                url:
                    "/Course/RemovePersonsFromPersonCourses/" +
                    $("#courseId").val() +
                    "/" +
                    JSON.stringify(peopleToRemove)
            })
            .done(function () {
                populateFacultyTable();
            });
    });

    $(document).on("click", "#courseDraftSubmitbtn", courseBasicInfo.submitDraftCourse);
    //
    // Show reject popover
    //
    $(document).on(
        "click",
        "#btnCourseNavBarStartRejectCourseRequest",
        hideAndShowCourseNavBarPopovers
    );
    //
    // Send approval
    //
    $(document).on("click", "#btnCourseNavBarApprove", function (e) {
        setCourseNavBarRequestApproval(e.target, true);
    });
    //
    // Send reject
    //
    $(document).on("click", "#btnCourseNavBarReject", function (e) {
        setCourseNavBarRequestApproval(e.target, false);
    });
    //
    // Close reject comment window and abort reject
    //
    $(document).on("click", "#btnCourseNavBarReject", hideCourseNavBarPopover);
    //
    // Initialize reject popover
    //
    initCourseNavBarPopOver();
    //
    // Post Course Report Approval Related
    //
    $(document).on("click", "#btnCourseNavBarPostCourseReportApproveSubmit", function (e) {
        setCourseNavBarPostCourseReportApproval(e.target, true);
    });

    $(document).on("click", "#btnCourseNavBarPostCourseReportRejectSubmit", function (e) {
        setCourseNavBarPostCourseReportApproval(e.target, false);
    });

    $(document).on(
        "click",
        "#btnCourseNavBarPostCourseRejectStart",
        hideAndShowCourseNavBarPostCoursePopovers
    );

    $(document).on(
        "click",
        "#btnCourseNavBarPostCourseRejectCancel",
        hideCourseNavBarPostCoursePopover
    );

    initCourseNavBarPostCoursePopOver();
    //
    $(document).on(
        "click",
        "#divAddRosterPersonTable table tbody tr .btnAddRosterMoreInfo",
        classbtnAddRosterMoreInfoClick
    );
    $(document).on(
        "click",
        ".classAddRosterPersonMoreInfoWrapperClose",
        classAddRosterPersonMoreInfoWrapperCloseClick
    );
    populateStudentTable();
    populateFacultyTable();

    $(document).on("click", ".js-view-form", function () {
        const disclosureId = $(this).data("id");
        dataaccess
            .get({ url: `/DisclosureForm/View/${disclosureId}` })
            .done(function (htmlResult) {
                $("#AddDisclosureModal .modal-content").html(htmlResult);
                const $form = $("#AddDisclosureForm");
                $form.find("button, input, textarea").prop("disabled", true);
                $("#addNewRelationship")
                    .closest("tr")
                    .hide();
            });
    });

    $(document).on("hide.bs.dropdown", ".keepMenuOpen", function (e) {
        if (e === undefined || e.clickEvent === undefined) {
            return false;
        }
        var target = $(e.clickEvent.target);
        if (target.hasClass(".keepMenuOpen") || target.parents(".keepMenuOpen").length) {
            return false; // returning false should stop the dropdown from hiding.
        } else {
            return true;
        }
    });
}

function updateStudentResultsView() {
    studentHasNextPage = $("#Student-HasNextPage").val();
    if (studentHasNextPage === "False") {
        $("#Student-Next").addClass("disabled");
    } else {
        $("#Student-Next").removeClass("disabled");
    }
    if (studentCurrentPage === 1) {
        $("#Student-Previous").addClass("disabled");
    } else {
        $("#Student-Previous").removeClass("disabled");
    }
    return studentCurrentPage === 1;
}

function updateFacultyResultsView() {
    facultyHasNextPage = $("#Faculty-HasNextPage").val();
    if (facultyHasNextPage === "False") {
        $("#Faculty-Next").addClass("disabled");
    } else {
        $("#Faculty-Next").removeClass("disabled");
    }
    if (facultyCurrentPage === 1) {
        $("#Faculty-Previous").addClass("disabled");
    } else {
        $("#Faculty-Previous").removeClass("disabled");
    }
    return facultyCurrentPage === 1;
}

function selectAllStudentsToggle() {
    $(".js-chk-student-row").prop("checked", $("#selectAllStudentsToggle").is(":checked"));
}

function selectAllFacultyToggle() {
    $(".chk-faculty-row").prop("checked", $("#selectAllFacultyToggle").is(":checked"));
}

function populateStudentSearchTable(args) {
    if (args != null && args.data != null && args.data === "SearchClicked") studentCurrentPage = 1;
    $("#SearchLoading").show();
    const keyword =
        $("#Student-SearchKeyword").val() === "" ? "undefined" : $("#Student-SearchKeyword").val();
    dataaccess
        .get({
            url:
                "/Course/" +
                $("#courseId").val() +
                "/ShowRosterModal/Student/" +
                studentCurrentPage +
                "/" +
                keyword
        })
        .done(function (result) {
            $("#addRoster")
                .find(".modal-content")
                .html(result);
            $("#addRoster").modal("show");
            $("#SearchLoading").hide();
            updateStudentResultsView();
        });
}

function populateFacultySearchTable(args) {
    if (args != null && args.data != null && args.data === "FacultyClicked") facultyCurrentPage = 1;
    const keyword =
        $("#Faculty-SearchKeyword").val() === "" ? "undefined" : $("#Faculty-SearchKeyword").val();
    dataaccess
        .get({
            url:
                "/Course/" +
                $("#courseId").val() +
                "/ShowRosterModal/Faculty/" +
                facultyCurrentPage +
                "/" +
                keyword
        })
        .done(function (result) {
            $("#addRoster")
                .find(".modal-content")
                .html(result);
            $("#addRoster").modal("show");
            updateFacultyResultsView();
        });
}

function populateStudentTable() {
    forms.showSpinner();
    dataaccess
        .get({ url: "/CourseRoster/StudentTable/" + $("#courseId").val() })
        .done(function (res) {
            $("#studentTable_wrapper").html(res);
            ethosBank.renderEthosBank();
            forms.hideSpinner();
        });
}

function populateFacultyTable() {
    forms.showSpinner();
    dataaccess
        .get({ url: "/CourseRoster/FacultyTable/" + $("#courseId").val() })
        .done(function (res) {
            $("#facultyTable_wrapper").html(res);
            forms.hideSpinner();
        });
}

function initCourseNavBarPopOver() {
    $("#btnCourseNavBarStartRejectCourseRequest").popover({
        container: "#divApproveReject",
        html: true,
        sanitize: false,
        animation: true,
        placement: "right",
        template:
            "<div class='popover' role='tooltip'><div class='arrow'> </div><h3 class='popover-header'></h3><div class='popover-body'></div></div>"
    });
}

function hideAndShowCourseNavBarPopovers(e) {
    $("#btnCourseNavBarStartRejectCourseRequest")
        .not($(this))
        .popover("hide");
    $("#btnCourseNavBarStartRejectCourseRequest").popover();
}

function hideCourseNavBarPopover(e) {
    $("#btnCourseNavBarStartRejectCourseRequest").popover("hide");
}

function setCourseNavBarRequestApproval(target, isApproved) {
    forms.showSpinner();
    const courseId = $("#courseId").val();
    const courseRequestId = $(target).attr("courseRequestId");
    let rejectedComment;
    params = {
        data: { isApproved: isApproved },
        url: "/Courses/CourseRequestApproval/" + courseRequestId
    };
    if (!isApproved) {
        rejectedComment = $("#txtCourseNavBarRejectReason").val();
        if (!rejectedComment) {
            $("#divCourseValidationWarning-" + courseRequestId).removeClass("hidden");
            forms.hideSpinner();
            return;
        }
        $("#divCourseNavBarValidationWarning").addClass("hidden");
        params.data.rejectedComment = rejectedComment;
    }

    dataaccess
        .put(params)
        .done(function () {
            window.location.href = application.baseUrl + "/course/index/" + courseId;
        })
        .fail(function () {
            window.location.href = application.baseUrl + "/course/index/" + courseId;
        });
}

//
// Post Course Report Processing
//
function hideAndShowCourseNavBarPostCoursePopovers(e) {
    $("#btnCourseNavBarPostCourseReportRejectStart")
        .not($(this))
        .popover("hide");
    $(e.target).popover();
}

function hideCourseNavBarPostCoursePopover(e) {
    $("#btnCourseNavBarPostCourseReportRejectStart-").popover("hide");
}

function initCourseNavBarPostCoursePopOver() {
    $("#btnCourseNavBarPostCourseReportRejectStart").popover({
        container: "#divCourseNavBarPostCourseReportApprove",
        html: true,
        sanitize: false,
        animation: true,
        placement: "right",
        template:
            "<div class='popover' role='tooltip'><div class='arrow'> </div><h3 class='popover-header'></h3><div class='popover-body'></div></div>"
    });
}

function setCourseNavBarPostCourseReportApproval(target, isApproved) {
    forms.showSpinner();
    const courseId = $("#courseId").val();
    const courseRequestId = $(target).attr("courseRequestId");
    let rejectedDecisionExplanation;
    const requestPayload = {
        url: "/Courses/PostCourseReportApproval/" + courseRequestId,
        data: { isApproved: isApproved }
    };
    if (!isApproved) {
        rejectedDecisionExplanation = $("#txtCourseNavBarPostCourseReportRejectReason").val();
        if (!rejectedDecisionExplanation) {
            $("#divCourseNavBarPostCourseReportValidationWarning").removeClass("hidden");
            return;
        }
        $("#divCourseNavBarPostCourseReportValidationWarning").addClass("hidden");
        requestPayload.data.rejectedComment = rejectedDecisionExplanation;
    }

    dataaccess
        .put(requestPayload)
        .done(function () {
            window.location.href = application.baseUrl + "/course/index/" + courseId;
        })
        .fail(function () {
            window.location.href = application.baseUrl + "/course/index/" + courseId;
        });
}

function classbtnAddRosterMoreInfoClick() {
    forms.showSpinner();
    const personid = $(this)
        .closest("tr")
        .data("personid");
    $("#divAddRosterPersonTable").addClass("hidden");
    dataaccess
        .get({ url: "/Course/GetAddRosterPersonMoreInfo/" + personid })
        .done(function (res) {
            $("#divAddRosterPersonMoreInfo").html(res);
            $("#divAddRosterPersonMoreInfoWrapper").removeClass("hidden");
            forms.hideSpinner();
        })
        .fail(function () {
            forms.hideSpinner();
            alert("Failed to load more information for person");
            $("#divAddRosterPersonTable").removeClass("hidden");
        });
}

function classAddRosterPersonMoreInfoWrapperCloseClick() {
    $("#divAddRosterPersonMoreInfoWrapper").addClass("hidden");
    $("#divAddRosterPersonTable").removeClass("hidden");
}

function exportStudentRosterToExcel() {
    const courseId = $("#courseId").val();
    window.location.href = `/courseroster/student-export/${courseId}`;
}

function exportFacultyRosterToExcel() {
    const courseId = $("#courseId").val();
    window.location.href = `/courseroster/faculty-export/${courseId}`;
}

function facultyStudentEvaluationPage() {
    const courseId = $("#courseId").val();
    window.open(`/CourseFacultyStudentEvaluation?courseId=${courseId}`);
}

function processingDataOn() {
    processingData = 1;
}

function processingDataOff() {
    processingData = 0;
}

function checkLoaRequired() {
    const commercialSupport = $("input[asp-for='CommercialSupport']:checked").val();
    const documentTypes = $("#courseDocumentsTable > tbody > tr").map(function () { return $(this).attr("data-filetype"); }).get();
    if (commercialSupport === "true") {
        $("#loaRequiredDiv").removeClass("hidden");
        if (documentTypes.includes(application.loaForCommercialSupportTypeName)) {
            $("#loaRequiredDiv").addClass("hidden");
        }
    }
}

export const course = {
    init: init,
    populateFacultyTable: populateFacultyTable,
    populateStudentSearchTable: populateStudentSearchTable,
    populateStudentTable: populateStudentTable,
    checkLoaRequired: checkLoaRequired
};
